import React, { useState } from "react";
import Modal from "react-modal";
import "./MessageBanner.css";

Modal.setAppElement("#root");

const MessageBanner = () => {
  const [modalIsOpen, setModalIsOpen] = useState(true);

  const closeModal = () => setModalIsOpen(false);

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentLabel="הודעת האתר"
      className="modal-content"
      overlayClassName="modal-overlay"
    >
      <div className="banner-header">
        <button className="close-button" onClick={closeModal} aria-label="סגירה">
          ×
        </button>
        <h2>התחדשנו!</h2>
      </div>

      <div className="banner-body">
        <p>אתר חדש, מקצועי ונוח יותר</p>
        <p>
          מוזמנת להיכנס:
          <br />
          <a
            href="https://www.justrentitdress.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            justrentitdress.com
          </a>
        </p>
      </div>
    </Modal>
  );
};

export default MessageBanner;